export function createValidationDataObject(valid = true, message = undefined) {
    return {
        valid,
        message
    };
}
